export const resetButton: HTMLButtonElement = document.getElementById('reset-button') as HTMLButtonElement;
export const loadingButton: HTMLButtonElement = document.getElementById("loading-button") as HTMLButtonElement;
export const emailInput: HTMLInputElement = document.getElementById("email") as HTMLInputElement;